import {useState, createContext, useEffect} from 'react';
import {getLanguageString} from './getLanguageInfo';

const initialState = {
  language: 'English',
  activeModule: '',
  shipping: true,
  geoFenceCode: '',
  shippingEst: '',
  dispatch: '',
  freeShippingThreshold: 0,
};

export const StateContext = createContext<any>(null);

export const StateProvider = ({children, queryLanguage}: any) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    setState((prevState: any) => {
      return {
        ...prevState,
        language: getLanguageString(queryLanguage),
      };
    });
  }, [queryLanguage]);

  return (
    <StateContext.Provider value={{state, setState}}>
      {children}
    </StateContext.Provider>
  );
};
